import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { ISubject, ISubjectCreateRequest, SubjectKind } from "common/types";
import api from "common/api";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";

interface CreateSubjectModalProps {
  show: boolean;
  onHide: () => void;
  onSubjectCreate: (subject: ISubject) => void;
  kind: SubjectKind;
}

function CreateSubjectModal({
  show,
  onHide,
  onSubjectCreate,
  kind,
}: CreateSubjectModalProps) {
  const [name, setName] = useState("");
  const [prepPrice, setPrepPrice] = useState("");
  const [lessonPrices, setLessonPrices] = useState([
    { duration: 60, price: "" },
    { duration: 90, price: "" },
    { duration: 120, price: "" },
  ]);

  const createSubject = async (subject: ISubjectCreateRequest) => {
    try {
      const response = await api.post("/subjects/", subject);
      toast.success("Predmet dodan");
      onSubjectCreate(response.data);
    } catch (error) {
      toast.error("Greška prilikom dodavanja predmeta");
      console.log(error);
    }
  };

  const handlePriceChange = (index: number, value: string) => {
    const newPrices = [...lessonPrices];
    newPrices[index].price = value;
    setLessonPrices(newPrices);
  };

  async function handleCreateSubject() {
    if (!name) {
      toast.error("Unesite naziv predmeta");
      return;
    }

    if (kind === SubjectKind.PREPARATION && !prepPrice) {
      toast.error("Unesite cijenu pripreme");
      return;
    }

    if (kind === SubjectKind.LESSON) {
      const validPrices = lessonPrices.filter((p) => p.price.trim() !== "");
      if (validPrices.length < 3) {
        toast.error("Unesite cijene za sve trajanje poduka");
        return;
      }
    }

    let subject: any = {
      name: name,
      kind: kind,
    };

    if (kind === SubjectKind.PREPARATION) {
      subject.prep_price = prepPrice;
    } else if (kind === SubjectKind.LESSON) {
      subject.prices = lessonPrices
        .filter((p) => p.price.trim() !== "")
        .map((p) => ({ duration: p.duration, price: p.price }));
    }

    await createSubject(subject);
    onHide();

    // Reset form
    setName("");
    setPrepPrice("");
    setLessonPrices([
      { duration: 60, price: "" },
      { duration: 90, price: "" },
      { duration: 120, price: "" },
    ]);
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Dodaj predmet</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Naziv
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        {kind === SubjectKind.PREPARATION ? (
          <div className="mb-3">
            <label htmlFor="prepPrice" className="form-label">
              Cijena priprema
            </label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                id="prepPrice"
                required
                value={prepPrice}
                onChange={(e) => setPrepPrice(e.target.value)}
              />
              <div className="input-group-text">€</div>
            </div>
          </div>
        ) : (
          <div className="mb-3">
            <label className="form-label">Cijene poduka</label>
            {lessonPrices.map((item, index) => (
              <div className="input-group mb-2" key={item.duration}>
                <span className="input-group-text" style={{ width: "90px" }}>
                  {item.duration} min
                </span>
                <input
                  type="text"
                  className="form-control"
                  value={item.price}
                  onChange={(e) => handlePriceChange(index, e.target.value)}
                  placeholder="Cijena"
                />
                <div className="input-group-text">€</div>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={onHide}>
          Odustani
        </Button>
        <Button onClick={handleCreateSubject}>Dodaj</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateSubjectModal;
